import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    errorTexts,
    generalIcons,
    message,
    myAccountTabs,
    status,
    transactionHistoryFilters,
    vanarExplorerUrl,
} from "../../utils/constants";
import { Button } from "../../components";
import { useStakingContext } from "../../context/staking-context";
import ValidatorDetailCard from "../../components/cards/ValidatorDetailCard";
import TransactionList from "../../components/TransactionList";
import {
    filterSearchAndSort,
    getTruncatedTrx,
    getValidatorImg,
} from "../../utils/helper";
import ClipLoaderComponent from "../../components/loader/ClipLoaderComponent";
import { useRootContext } from "../../context/app-context";
import Confirmation from "../../components/modals/Confirmation";
import { toast } from "react-toastify";
import stakingAbi from "../../blockchain/abi/staking.json";
import { executeContractWrite } from "../../utils/wagmi.helper";
import { AddTrxToDB, fetchChange } from "../../utils/firebase.helper";
import ConfirmationTrx from "../../components/modals/ConfirmationTrx";

function MyAccount() {
    const navigate = useNavigate();
    const {
        userDelegators,
        userValidators,
        userTrxHistory,
        setSelectedValidator,
        isFetchingTrx,
        isFetchingMyAccountDetails,
        setBtnloading,
        setTrx,
        setTrxData,
        btnloading,
        isClaimModalOpen,
        setIsClaimModalOpen,
        fetchUserData,
        fetchUserTransactions,
        validators,
        lastClaimDoc, lastTransactionDoc,
        setIsFetchingMyAccountDetails,
        setIsFetchingTrx,
        fetchValidators,
        isDelegatorModalOpen, setIsDelegatorModalOpen,
        handleWalletInfo
    } = useStakingContext();
    const { address, isConnected } = useRootContext();
    const [isSyncing, setIsSyncing] = useState(false)
    const [isSynced, setIsSynced] = useState(false)
    const [showClaimBtn, setShowClaimBtn] = useState(false);

    // const previousAccountTab = localStorage?.getItem("previousAccountTab");
    const [currentTab, setCurrentTab] = useState("myAccount");
    const [currentRewards, setCurrentRewards] = useState();
    const [selectedData, setSelectedData] = useState();
    const total_unclaimed_commission =
        currentRewards?.total_unclaimed_comission ?? 0;
    const total_unclaimed_rewards =
        currentRewards?.total_unclaimed_rewards ?? 0;
    const totalRewardToClaim =
        total_unclaimed_commission + total_unclaimed_rewards;

    const [currentTrxFilter, setTurrentTrxFilter] =
        useState("All Transactions");

    const filteredAndSortedTransactions = filterSearchAndSort(userTrxHistory, {
        statusKey: "type",
        selectedStatus:
            currentTrxFilter === "All Transactions" ? "" : currentTrxFilter,
        searchKey: "",
        searchTerm: "",
        sortKey: "date",
        sortOrder: "desc",
    });
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [sortConfig, setSortConfig] = useState({
        key: "",
        direction: "descending",
    }); // Sorting state

    useEffect(() => {
        if (isClaimModalOpen) {
            setIsClaimModalOpen(false);
        }
    }, []);

    const handleSort = (key) => {
        if (sortConfig.key === key) {
            // Toggle between ascending, descending, and reset (default state)
            if (sortConfig.direction === "ascending") {
                setSortConfig({ key, direction: "descending" });
            } else if (sortConfig.direction === "descending") {
                setSortConfig({ key: "", direction: "" }); // Reset to default state
            }
        } else {
            setSortConfig({ key, direction: "ascending" });
        }
    };

    const handleRefresh = async () => {
        if (currentTab === "transactionHistory") {
            handleFetchUserTransactions()
        } else {
            handleFetchUserData()
        }
    }

    const sortedTransactions = React.useMemo(() => {
        // Ensure filteredAndSortedValidators is an array
        const validData = Array.isArray(filteredAndSortedTransactions)
            ? filteredAndSortedTransactions
            : [];
        let sortableData = [...validData];

        if (sortConfig.key) {
            sortableData.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === "ascending" ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === "ascending" ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [filteredAndSortedTransactions, sortConfig]);

    const ClaimReward = async () => {
        // localStorage.setItem("trxStatus", status.PENDING);
        setBtnloading(true);

        try {
            const stakeContract = selectedData?.contract_address;

            const rewardAmount = totalRewardToClaim;

            const data = {
                stakeContract,
                tokenContractAbi: stakingAbi,
                userWalletAddress: address,
                action: "claimReward",
                publicClient: null,
            };

            const hash = await executeContractWrite(data);

            const obj = {
                t_hash: hash,
                type: status.CLAIM_REWARD,
            };

            // const trxDataObj = {
            //     txId: hash,
            //     from: address,
            //     txType: "Claim Reward",
            //     to: stakeContract,
            //     tvk: rewardAmount,
            // };

            // setTrxData(trxDataObj);

            toast.success(
                <>
                    <div className="flex items-center gap-4">
                        <span className="icon">{generalIcons.success}</span>
                        <div className="">
                            <h5>Hang tight—your transaction is surfing the blockchain waves!</h5>
                            <p>
                                Transaction ID:{" "}
                                <a
                                    href={`${vanarExplorerUrl}/tx/${hash}`}
                                    target="_blank"
                                    className="address"
                                    rel="noreferrer"
                                >
                                    {getTruncatedTrx(hash)}
                                </a>
                            </p>
                        </div>
                    </div>{" "}
                    <span></span>
                </>,
            );

            // localStorage.setItem("tx", hash);

            setIsClaimModalOpen(false)
            setIsDelegatorModalOpen(false)
            setBtnloading(false);
            setShowClaimBtn(false)
            localStorage.setItem("trxData", JSON.stringify(obj));
            setIsSyncing(true)

            // navigate("/my-account")

            // setTrx(obj);
            // const db_data = {
            //     txId: hash,
            //     from: address,
            //     amount: Number(rewardAmount),
            //     txType: "Claim Reward",
            //     status: "pending",
            //     to: stakeContract,
            //     date: Math.floor(Date.now() / 1000),
            // };

            // AddTrxToDB(db_data);
        } catch (error) {
            if (error?.cause?.code) {
                toast.error(
                    <div className="flex items-center gap-4">
                        <span className="icon">{generalIcons.error}</span>
                        <div className="">
                            <p>{error?.shortMessage}</p>
                        </div>
                    </div>,
                );
            } else if (error?.shortMessage === errorTexts.gas_error) {
                toast.error(
                    <div className="flex items-center gap-4">
                        <span className="icon">{generalIcons.error}</span>
                        <div className="">
                            <p>{errorTexts.insufficient_funds_for_gas}</p>
                        </div>
                    </div>,
                );
            } else {
                toast.error(
                    <div className="flex items-center gap-4">
                        <span className="icon">{generalIcons.error}</span>
                        <div className="">
                            <p>{error?.shortMessage}</p>
                        </div>
                    </div>,
                );
            }
            setBtnloading(false);
            // localStorage.setItem("trxStatus", status.CANCELLED);
        }
    };

    const handleFetchUserTransactions = async () => {
        setIsFetchingTrx(true)
        await fetchUserTransactions()
        setIsFetchingTrx(false)
    }
    const handleFetchUserData = async () => {
        setIsFetchingMyAccountDetails(true)
        await fetchUserData()
        setIsFetchingMyAccountDetails(false)
    }



    useEffect(() => {
        if (isConnected && validators) {
            if (currentTab === "transactionHistory") {
                fetchChange(`/vanar-dpos/data/user_data`, address, handleFetchUserTransactions, handleWalletInfo)
            } else {
                fetchChange(`/vanar-dpos/data/user_data`, address, handleFetchUserData, handleWalletInfo, setIsSyncing, setIsFetchingMyAccountDetails, setIsSynced, address)
            }
        }

    }, [isConnected, validators, currentTab])

    useEffect(()=>{
        const hasTx = localStorage?.getItem("trxData");
        if(hasTx && !isSynced){
            setIsSyncing(true)
        }else{
            localStorage?.removeItem("trxData")
        }
    },[isSynced])


    return (
        <div className="relative min-h-screen h-full pb-16 lg:pb-[100px]">
            <div className="max-w-container px-3 lg:px-[25px] xl:px-[33px] m-auto">
                <div className="flex items-center">
                    <Link
                        to={"/"}
                        className="flex items-center -tracking-08 w-fit text-xsm font-medium text-dim"
                    >
                        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-lightGray/[0.06] p-1 mr-4 *:w-full *:h-full">
                            {generalIcons.backArrow}
                        </div>
                        <span className="opacity-[50%] mr-1">Overview / </span>
                    </Link>
                    <span className="text-xsm">My Account</span>
                </div>
                <div className="mt-11 mb-6 md:mb-[60px]">
                    <h1 className="heading text-textcolor font-bold lg:-tracking-37 mb-7 md:mb-10">
                        {myAccountTabs[currentTab]}
                    </h1>

                    <div className="flex justify-between gap-4 flex-col laptop:flex-row">
                        <div className="flex items-center gap-2">
                            <div className="flex items-center rounded-xl bg-[#1A1A1A] text-primaryWhite/50 gap-2 text-sm lg:text-base leading-none font-medium *:h-12 *:whitespace-nowrap w-full md:w-fit *:w-full *:sm:w-[50%] *:md:w-fit">
                                {Object.entries(myAccountTabs).map(
                                    ([key, value]) => (
                                        <div
                                            key={key}
                                            onClick={() => {
                                                localStorage?.setItem(
                                                    "previousAccountTab",
                                                    key,
                                                );
                                                setCurrentTab(key);
                                                setHasMore(true);
                                            }}
                                            className={`flex items-center justify-center capitalize py-[10px] px-3 md:px-6 rounded-xl cursor-pointer ${currentTab === key
                                                ? "bg-primaryWhite text-[#06080C]"
                                                : ""
                                                }`}
                                        >
                                            {value}
                                        </div>
                                    ),
                                )}
                            </div>
                            <button onClick={handleRefresh} disabled={isFetchingTrx || isFetchingMyAccountDetails} className={`w-[50px] h-[48px] bg-[#1A1A1A] rounded-xl flex items-center justify-center *:w-[50%] *:h-[50%] ${isFetchingTrx || isFetchingMyAccountDetails ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}>
                                {generalIcons.refresh}
                            </button>
                        </div>
                        {currentTab !== "myAccount" && (
                            <div className="flex flex-wrap lg:flex-nowrap gap-[10px] *:h-12 *:whitespace-nowrap">
                                {Object.entries(transactionHistoryFilters).map(
                                    ([key, value]) => (
                                        <div
                                            key={key}
                                            onClick={() =>
                                                setTurrentTrxFilter(value)
                                            }
                                            className={`px-3 py-[10px] rounded-xl flex items-center text-sm lg:text-base font-medium cursor-pointer ${currentTrxFilter === value
                                                ? "bg-[#50FDDB]/10 text-[#50FDDB]"
                                                : "bg-[#1A1A1A] text-primaryWhite/40"
                                                } `}
                                        >
                                            {value}
                                        </div>
                                    ),
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {currentTab === "myAccount" ? (
                    <>
                        {userValidators?.length > 0 && (
                            <div className="w-full mb-10">
                                <h2 className="text-xl md:text-[38px] text-dim font-semibold leading-none md:leading-[38px] -tracking-[1.36px] mb-3">
                                    Validators
                                </h2>
                                <p className="text-sm md:text-base leading-6 md:leading-7 -tracking[0.8px] font-normal text-dim/50">
                                    Secure the network and earn rewards by
                                    running a validator node.
                                </p>
                                {isFetchingMyAccountDetails && (
                                    <ClipLoaderComponent
                                        size={80}
                                        customClass={
                                            "min-h-[250px] justify-center"
                                        }
                                    />
                                )}
                                {!isFetchingMyAccountDetails &&
                                    (userValidators?.length === 0 ||
                                        userValidators === undefined) && (
                                        <div className="min-h-[250px] flex items-center justify-center">
                                            <h2 className="text-[24px] leading-6 md:text-[30px] md:leading-[30px] font-semibold -tracking-16 text-textcolor">
                                                You are not a Validator Yet.
                                            </h2>
                                        </div>
                                    )}
                                {!isFetchingMyAccountDetails &&
                                    userValidators?.length > 0 && (
                                        <div className="grid md:grid-cols-2 lg:grid-cols-3 laptop:grid-cols-4 gap-3 mt-[30px]">
                                            {userValidators?.map(
                                                (validator) => (
                                                    <ValidatorDetailCard
                                                        key={validator?.id}
                                                        icon={getValidatorImg(
                                                            validator?.name,
                                                        )}
                                                        title={validator?.name}
                                                        tagText={
                                                            validator?.status
                                                        }
                                                        validatorData={
                                                            validator
                                                        }
                                                        isDelegator={false}
                                                        rewards={
                                                            validator?.rewards
                                                        }
                                                        setSelectedValidator={
                                                            setSelectedValidator
                                                        }
                                                        setBtnloading={
                                                            setBtnloading
                                                        }
                                                        setTrxData={setTrxData}
                                                        setTrx={setTrx}
                                                        userWalletAddress={
                                                            address
                                                        }
                                                        btnloading={btnloading}
                                                        isClaimModalOpen={
                                                            isClaimModalOpen
                                                        }
                                                        setIsClaimModalOpen={
                                                            setIsClaimModalOpen
                                                        }
                                                        setCurrentRewards={
                                                            setCurrentRewards
                                                        }
                                                        setSelectedData={
                                                            setSelectedData
                                                        }
                                                        ClaimReward={ClaimReward}
                                                        showClaimBtn={showClaimBtn}
                                                        setShowClaimBtn={setShowClaimBtn}
                                                    />
                                                ),
                                            )}
                                        {isClaimModalOpen && (
                                            <Confirmation
                                                setIsClaimModalOpen={
                                                    setIsClaimModalOpen
                                                }
                                                rewards={currentRewards}
                                                ClaimReward={ClaimReward}
                                                btnloading={btnloading}
                                                isDelegator={false}
                                                message={message?.validator}
                                            />
                                        )}
                                        </div>
                                    )}
                            </div>
                        )}
                        <div className="w-full">
                            <h2 className="text-xl md:text-[38px] text-dim font-semibold leading-none md:leading-[38px] -tracking-[1.36px] mb-3">
                                Delegators
                            </h2>
                            <p className="text-sm md:text-base leading-6 md:leading-7 -tracking[0.8px] font-normal text-dim/50">
                                Delegate your tokens to a trusted validator and
                                earn rewards.
                            </p>

                            {isFetchingMyAccountDetails && (
                                <ClipLoaderComponent
                                    size={80}
                                    customClass={"min-h-[250px] justify-center"}
                                />
                            )}
                            {!isFetchingMyAccountDetails &&
                                (userDelegators?.length === 0 ||
                                    userDelegators === undefined || userDelegators === null) && (
                                    <div className="min-h-[250px] flex items-center justify-center">
                                        <div className="flex items-center gap-4 *:h-12 *:md:h-[58px] w-full md:w-fit *:w-full *:sm:w-[50%] *:md:w-fit">
                                            <Button
                                                className="bg-primaryWhite text-[#06080C] py-[10px] px-[18px] leading-none"
                                                onClick={() =>
                                                    navigate("/all-validator")
                                                }
                                            >
                                                Delegate
                                            </Button>
                                        </div>
                                    </div>
                                )}

                            {!isFetchingMyAccountDetails &&
                                userDelegators?.length > 0 && (
                                    <div className="grid md:grid-cols-2 lg:grid-cols-3 laptop:grid-cols-4 gap-3 mt-[30px]">
                                        {userDelegators?.map((delegator) => (
                                            <ValidatorDetailCard
                                                key={delegator?.id}
                                                icon={getValidatorImg(
                                                    delegator?.name,
                                                )}
                                                title={delegator?.name}
                                                tagText={delegator?.status}
                                                delegatorData={delegator}
                                                setSelectedValidator={
                                                    setSelectedValidator
                                                }
                                                isDelegator={true}
                                                setBtnloading={setBtnloading}
                                                setTrxData={setTrxData}
                                                setTrx={setTrx}
                                                userWalletAddress={address}
                                                rewards={delegator?.rewards}
                                                btnloading={btnloading}
                                                isClaimModalOpen={
                                                    isClaimModalOpen
                                                }
                                                setIsClaimModalOpen={
                                                 setIsDelegatorModalOpen
                                                }
                                                setCurrentRewards={
                                                    setCurrentRewards
                                                }
                                                setSelectedData={
                                                    setSelectedData
                                                }
                                                ClaimReward={ClaimReward}
                                                showClaimBtn={showClaimBtn}
                                                setShowClaimBtn={setShowClaimBtn}                                            />
                                        ))}
                                        {isDelegatorModalOpen && (
                                            <Confirmation
                                                setIsClaimModalOpen={
                                                    setIsDelegatorModalOpen
                                                }
                                                rewards={currentRewards}
                                                ClaimReward={ClaimReward}
                                                btnloading={btnloading}
                                                isDelegator={true}
                                            />
                                        )}
                                    </div>
                                )}
                        </div>
                    </>
                ) : (
                    <>
                        <TransactionList
                            userTrxHistory={sortedTransactions}
                            userDelegators={userDelegators}
                            handleSort={handleSort}
                            isFetchingTrx={isFetchingTrx}
                            setIsLoadingMore={setIsLoadingMore}
                            hasMore={hasMore}
                            setHasMore={setHasMore}
                            isLoadingMore={isLoadingMore}
                            sortConfig={sortConfig}
                            fetchUserTransactions={fetchUserTransactions}
                            lastClaimDoc={lastClaimDoc}
                            lastTransactionDoc={lastTransactionDoc}
                        />
                        {/* {hasMore && sortedTransactions.length > 0 && (
                            <LoadMoreButton isLoadingMore={isLoadingMore} />
                        )} */}
                    </>
                )}
            </div>
            {isSyncing && <ConfirmationTrx
                setIsClaimModalOpen={
                    setIsClaimModalOpen
                }
                rewards={currentRewards}
                ClaimReward={ClaimReward}
                btnloading={btnloading}
            />}
        </div>
    );
}

export default MyAccount;
